// app/src/lib/useIsMobile.js — the JS side of the 680px mobile breakpoint (CSS handles layout
// reflow; this drives the divergent bits — pickers open a bottom SHEET on mobile vs a popover on
// desktop). Matches app.css's `@media (max-width: 680px)`.

import { useEffect, useState } from 'react';

const QUERY = '(max-width: 680px)';

export function useIsMobile() {
  const [mobile, setMobile] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(QUERY).matches : false);
  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia(QUERY);
    const on = (e) => setMobile(e.matches);
    mq.addEventListener('change', on);
    setMobile(mq.matches);
    return () => mq.removeEventListener('change', on);
  }, []);
  return mobile;
}
